import { Environment, getDappEnvironment, getDappEnvironmentDelay } from './dappEnvironment';
import { androidGetCurrentBTYAddress, androidSignRawTransaction, androidSignTransactionGroup, androidConfigPrivCache } from './androidJsBridge';
import { iosGetCurrentBTYAddress, iosSignRawTransaction, iosSignTransactionGroup, iosConfigPrivCache } from './iosJsBridge';
import BtyBaseSdk from '@33cn/chain33-rpc-api';
var chain33Rpc = new BtyBaseSdk('https://jiedian1.bityuan.com:8801');
var myWindow = window;
export function getCurrentBTYAddress() {
    return getDappEnvironmentDelay().then(function (env) {
        switch (env) {
            case Environment.pcWallet:
                return myWindow.chain33Wallet.chooseAddrToPlay().then(function (res) { return res.addr; });
            case Environment.lightWallet:
                return myWindow.btyExtensionProvider.getCurrentAccount().then(function (res) {
                    if (res.error) {
                        return Promise.reject(res.error);
                    }
                    else {
                        return res.result && res.result.account && res.result.account.address || '';
                    }
                });
            case Environment.androidBiWallet:
                return androidGetCurrentBTYAddress();
            case Environment.iosBiWallet:
                return iosGetCurrentBTYAddress();
            default:
                return Promise.reject('invalidEnvironment');
        }
    });
}
/**
 * @description 签名
 * @param tx    未签名tx
 * @param title  标题     pc钱包，轻钱包必须
 * @param address  地址   pc钱包必须
 */
export function signTx(tx, title, address) {
    var formatTx = tx;
    if (tx.startsWith('0x')) {
        formatTx = tx.slice(2);
    }
    switch (getDappEnvironment()) {
        case Environment.pcWallet:
            return myWindow.chain33Wallet.sign(formatTx, address, '1h', title).then(function (res) {
                if (res.error) {
                    return Promise.reject(res.err);
                }
                else {
                    return res.signed;
                }
            });
        case Environment.lightWallet:
            return myWindow.btyExtensionProvider.signTx({
                tx: formatTx,
                title: title,
            }).then(function (res) {
                console.log('signTx res', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return res.signedTx;
            });
        case Environment.androidBiWallet:
            return androidSignRawTransaction(formatTx).then(function (res) {
                console.log('打印Android签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        case Environment.iosBiWallet:
            return iosSignRawTransaction(formatTx).then(function (res) {
                console.log('打印IOS签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        default:
            return Promise.reject('invalidEnvironment');
    }
}
/**
 * @description 请求构造代扣交易组并签名
 * @export
 * @param {string} tx
 * @param {string} title
 * @param {string} address
 * @returns {Promise<any>}
 */
export function signTxGroup(tx, exer, withhold) {
    if (withhold === void 0) { withhold = 1; }
    var txs = tx.split(',');
    txs = txs.map(function (tx) {
        if (tx.startsWith('0x')) {
            return tx.slice(2);
        }
        return tx;
    });
    switch (getDappEnvironment()) {
        case Environment.androidBiWallet:
            return androidSignTransactionGroup(txs.join(','), exer, withhold).then(function (res) {
                console.log('打印Android签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        case Environment.iosBiWallet:
            return iosSignTransactionGroup(txs.join(','), exer, withhold).then(function (res) {
                console.log('打印IOS签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        default:
            return Promise.reject('invalidEnvironment');
    }
}
/**
 * @description 配置私钥缓存  0:默认 1：缓存私钥 -1：清除私钥
 * @param {number} cachePriv
 * @export
 * @returns {Promise<any>}
 */
export function configPrivCache(cachePriv) {
    if (cachePriv === void 0) { cachePriv = 0; }
    switch (getDappEnvironment()) {
        case Environment.lightWallet:
            return Promise.resolve(true);
        case Environment.androidBiWallet:
            return androidConfigPrivCache(cachePriv).then(function (res) {
                console.log("android \u94B1\u5305\u79C1\u94A5\u7F13\u5B58\u914D\u7F6E " + res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return res;
            });
        case Environment.iosBiWallet:
            return iosConfigPrivCache(cachePriv).then(function (res) {
                console.log("ios \u94B1\u5305\u79C1\u94A5\u7F13\u5B58\u914D\u7F6E " + res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return res;
            });
            ;
        default:
            return Promise.reject('invalidEnvironment');
    }
}
/**
 * @description 单笔交易签名 优化版
 * @export
 * @param {ISignTxCommon} {
 *   tx,  未签名tx
 *   title = '',  标题     pc钱包，轻钱包必须
 *   address  地址   pc钱包必须
 * }
 * @returns {Promise<any>}
 */
export function signTxCommon(_a) {
    var tx = _a.tx, _b = _a.title, title = _b === void 0 ? '' : _b, address = _a.address;
    var formatTx = tx;
    if (tx.startsWith('0x')) {
        formatTx = tx.slice(2);
    }
    switch (getDappEnvironment()) {
        case Environment.pcWallet:
            return myWindow.chain33Wallet.sign(formatTx, address, '1h', title).then(function (res) {
                if (res.error) {
                    return Promise.reject(res.err);
                }
                else {
                    return res.signed;
                }
            });
        case Environment.lightWallet:
            return myWindow.btyExtensionProvider.signTx({
                tx: formatTx,
                title: title,
            }).then(function (res) {
                console.log('signTx res', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return res.signedTx;
            });
        case Environment.androidBiWallet:
            return androidSignRawTransaction(formatTx).then(function (res) {
                console.log('打印Android签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        case Environment.iosBiWallet:
            return iosSignRawTransaction(formatTx).then(function (res) {
                console.log('打印IOS签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        default:
            return Promise.reject('invalidEnvironment');
    }
}
/**
 * @description 交易组签名 兼容btypay
 * @export
 * @param {ISignTxGroupCommon} {
 *   tx: 交易hash，使用,连接  必须
 *   exer: 执行器  币钱包必须
 *   withhold: 是否代扣 -1 不代扣  1 代扣
 *   url 交易待发送的url
 * }
 * @returns {Promise<any>}
 */
export function signTxGroupCommon(_a) {
    var tx = _a.tx, exer = _a.exer, withhold = _a.withhold, url = _a.url;
    var txs = tx.split(',');
    txs = txs.map(function (tx) {
        if (tx.startsWith('0x')) {
            return tx.slice(2);
        }
        return tx;
    });
    switch (getDappEnvironment()) {
        case Environment.lightWallet:
            return chain33Rpc.createRawTxGroup(txs, 'https://jiedian1.bityuan.com:8801').then(function (res) {
                console.log('createRawTxGroup res', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return myWindow.btyExtensionProvider.signGroupTx({
                    tx: res.result,
                    url: url,
                    isSend: false,
                });
            }).then(function (res) {
                console.log('signTxGroupCommon res', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                return res.result;
            }).catch(function (error) { return Promise.reject(error); });
        case Environment.androidBiWallet:
            return androidSignTransactionGroup(txs.join(','), exer, withhold).then(function (res) {
                console.log('打印Android签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        case Environment.iosBiWallet:
            return iosSignTransactionGroup(txs.join(','), exer, withhold).then(function (res) {
                console.log('打印IOS签名结果', res);
                if (res.error) {
                    return Promise.reject(res.error);
                }
                else {
                    return res.signHash;
                }
            });
        default:
            return Promise.reject('invalidEnvironment');
    }
}
//# sourceMappingURL=index.js.map